import { ListChecks, Pencil } from "phosphor-react";
import React, { useEffect, useMemo, useState } from "react";
import api from "../../../api/api";
import {
  useDealsContext,
  ACTIONS as DEAL_ACTIONS,
} from "../../../context/DealsProvider";
import {
  useModalHistory,
  ACTIONS as MODAL_ACTIONS,
} from "../../../context/ModalHistoryProvider";
import { inputWithFloatingLabel } from "../../../HOC/inputWithFloatingLabel";
import { inputWithStyle } from "../../../HOC/inputWithStyle";
import { inputWithSuffix } from "../../../HOC/inputWithSuffix";
import colors from "../../../utils/constants/COLORS";
import { DEAL_STATUSES, DEAL_TYPES, USER_KEY } from "../../../utils/constants/SYSTEM";
import parseDecimal from "../../../utils/helpers/parseDecimal";
import { get } from "../../../utils/helpers/storage";
import useType from "../../../utils/hooks/useType";
import { CancelButton } from "../../Controls/CancelButton";
import { ConfirmButton } from "../../Controls/ConfirmButton";
import InputBase from "../../Inputs/InputBase";
import Select from "../../Inputs/Select";
import Modal from "../../Modal/Modal";
import QueueStyle from "../../Styled/Queue.style";
import StackStyle from "../../Styled/Stack.style";
import calculateVAT, { VAT_TYPES } from "../../../utils/helpers/calculateVAT";
import { useSystemContext } from "../../../context/SystemProvider";
import useToast, { TOAST_TYPES } from "../../../utils/hooks/useToast";

export default function UpdateDealModal({ items, scopeID }) {
  const [fieldToUpdate, setFieldToUpdate] = useType("string", "");
  const [newValue, setNewValue] = useState("");
  const [dealsToUpdate, setDealsToUpdate] = useType("array", []);
  const [deliveryFee, setDeliveryFee] = useType("object", {});
  const [licenseAndRegFee, setLicenseAndRegFee] = useType("object", {});

  const [{ vat },] = useSystemContext();
  const [{ deals }, dispatchDeals] = useDealsContext();
  const [, dispatchModalHistory] = useModalHistory();
  const popEnd = () =>
    dispatchModalHistory({
      type: MODAL_ACTIONS.POP_END,
    });
  const [addToast] = useToast();

  // Get Dealership Fees
  useEffect(() => {
    (async () => {
      const dealerShipFeesResp = await api.getDealershipFees();
      console.log('dealerShipFeesResp', dealerShipFeesResp);

      const deliveryFeeItem = dealerShipFeesResp.find(fee => fee?.generic_Name === "Delivery Fee");
      setDeliveryFee(deliveryFeeItem);
      const licenseAndRegFeeItem = dealerShipFeesResp.find(fee => fee?.generic_Name === "Licence And Registration Fee");
      setLicenseAndRegFee(licenseAndRegFeeItem);
    })();
  }, [setDeliveryFee, setLicenseAndRegFee]);

  useEffect(() => {
    const tempDeals = items.map((i) => {
      return deals.flat().find((d) => d[scopeID] === i);
    });
    console.log('tempDeals', tempDeals);

    if (scopeID === "preloaded_Deals_ID") {
      const result = tempDeals?.map(async deal => {
        if (deal?.plD_Type === DEAL_TYPES.INSTALMENT_PRICE) {
          const resp = await api.getNewSchemeDealInfo(deal?.preloaded_Deals_ID);
          console.log('getNewSchemeDealInfo', resp);
          return resp;
        } else if (deal?.plD_Type === DEAL_TYPES.LIST_PRICE) {
          const resp = await api.getNewListPriceDealInfo(deal?.preloaded_Deals_ID);
          console.log('getNewListPriceDealInfo', resp);
          return resp;
        }
      })
      Promise.all(result).then(resp => setDealsToUpdate(resp));
    } else if (scopeID === "used_Car_ID") {
      const result = tempDeals?.map(async deal => {
        const resp = await api.getUsedDealInfo(deal?.used_Car_ID);
        console.log('getUsedDealInfo', resp);
        return resp;
      });
      Promise.all(result).then(resp => setDealsToUpdate(resp));
    }
  }, [items, scopeID, deals, setDealsToUpdate])

  console.log('deals', deals);
  console.log("dealsToUpdate", dealsToUpdate);

  const options = useMemo(() =>
    dealsToUpdate?.length === 0 ? []
      : Object.keys(dealsToUpdate[0])
        .filter(key => key !== "brand" && key !== "car_ID" && key !== "deal_JSON" && key !== "deal_Name" && key !== "mM_Code" && key !== "model" && key !== "preloaded_Deals_ID" && key !== "quote_Create_Date" && key !== "quote_Type" && key !== "range" && key !== "search_Barcode" && key !== "total_Cost_Of_Credit" && key !== "transaction_Datetime" && key !== "transaction_Type" && key !== "transmission")
        .map((d) =>
          d.replaceAll("_", " ")
  ), [dealsToUpdate]);
  const handleOptionChange = (value) => {
    setFieldToUpdate(value.replaceAll(" ", "_"));
    setNewValue("");
  }

  const handleSubmit = () => {
    const updatedDeals = dealsToUpdate.map(async (d) => {
      const deal = { ...d };
      deal[fieldToUpdate] = newValue;
      if(fieldToUpdate === "deal_Status") {
        deal[fieldToUpdate] = newValue ? "QuoteApproved" : "QuoteStopped";
      }
      
      console.log('newDeal', deal);

      if (scopeID === "preloaded_Deals_ID") {
        if (deal?.plD_Type === DEAL_TYPES.INSTALMENT_PRICE) {
          /*
          "preloaded_Deals_ID": 13478,
          "mM_Code": "10323260",
          "brand": "Chery",
          "range": "Tiggo 4 Pro",
          "model": "1.5 Comfort",
          "transaction_Type": "QUOTE",
          "deal_Status": "Active",
          "car_ID": "CherTigg4_1e7",
          "transaction_Datetime": "10/13/2023 15:01:54",
          "deal_Request_Status": "New       ",
          "quote_Create_Date": "10/01/2023 00:00:00",
          "quote_Type": "M",
          "quote_Reusable_Start_Date": "10/01/2023 08:59:00",
          "quote_Reusable_End_Date": "12/15/2023 00:00:00",
          "deal_Name": "Total: R 502218.97, Instalment: R 5030, Rate: % 12.95",
          "plD_Type": "InstalmentPrice",
          "notes": "5 year service plan. 5 year warranty.",
          "search_Barcode": "Chery_Tiggo 4 Pro_1.5 Comfort_5030_10323260_5 year service plan. 5 year warranty.",
          "deal_Assistance": 0.00,
          "instalment": 5030.00,
          "retail_Incl": 345900.00,
          "rate_Type": "Linked",
          "rate_Percent": 12.95,
          "deposit": 10.00,
          "period": 72,
          "balloon_Percent": 40.00,
          "balloon_Amount": 138360.00,
          "total_Cost_Of_Credit": 502218.97,
          "transmission": "CVT",
          "fuel_Type": "petrol",
          "deal_JSON": "{\"dealname-id\":\"Total: R 502218.97, Instalment: R 5030, Rate: % 12.95\",\"submitType\":\"goLive\",\"currentDealType\":\"Live\",\"PreloadedDealsID\":\"\",\"DealStatus\":\"Active\",\"ToggleStatus\":\"\",\"dealer_comments\":\"5 year service plan. 5 year warranty.\",\"quoteValidity\":\"\",\"PLDType\":\"InstalmentPrice\",\"car-section\":{\"brand\":\"Chery\",\"range\":\"Tiggo 4 Pro\",\"model\":\"1.5 Comfort\",\"gearshift\":\"CVT\",\"fueltype\":\"petrol\",\"variant\":\"CherTigg4_1e7\",\"dealer_id\":\"\",\"user_id\":\"26\",\"car_status\":\"New\",\"mileage\":\"0\",\"vin\":null,\"color\":\"Various\"},\"options-section\":[],\"additional-fees\":[],\"price-section\":{\"standard_price\":300782.61,\"discount\":0,\"discount_percent\":0,\"dealer_price\":0,\"total_extras\":0,\"on_road_costs\":0,\"other_costs\":0,\"othercosts_reason\":\"\",\"total_excl\":300782.61,\"nonVAT_costs\":0,\"nonVAT\":0,\"vat\":0,\"total_total\":345900,\"spotter-fee\":0},\"delivery-section\":{},\"dealer_attachments\":[],\"validity-section\":{\"quoteSentDate\":\"\",\"quoteValidFor\":\"1\",\"quoteToOtherCustomers\":\"2\",\"quoteReusableStartDate\":\"10/01/2023 08:59:00\",\"quoteReusableEndDate\":\"2023-12-15T00:00\",\"internalNotes\":\"Portal_Upload\",\"NoStock\":\"\",\"NoStockUntilDate\":\"\",\"NoStockComments\":\"\"},\"totals\":{\"standard_price\":0,\"discount\":0,\"discount_percent\":0,\"price\":0,\"on_road_costs\":0,\"other_costs\":0,\"extras\":0,\"excl\":0,\"total\":0,\"vat\":0,\"nonVAT\":0,\"incl\":0,\"trade_in_offer\":0,\"trade_in_assist\":0,\"trade_in\":0,\"net\":0},\"instalment\":{\"Instalment\":5030,\"InstalmentFee\":0,\"Instalment_ExclFee\":5030,\"Instalment_InclFee\":5030,\"Retail_Incl\":345900,\"RateType\":\"Linked\",\"RatePercent\":12.95,\"Deposit\":10,\"Period\":72,\"BalloonPercent\":40,\"BalloonAmount\":138360,\"TotalCostOfCredit\":502218.97,\"OEMSubversion\":0,\"DealerSubversion\":0,\"PIC_Code\":\"\",\"ApprovedCAT\":\"\",\"SchemeDealName\":\"Total: R 502218.97, Instalment: R 5030, Rate: % 12.95\",\"Comments\":\"5 year service plan. 5 year warranty.\"},\"dealer_comments_excerpt\":\"5 year service plan. 5 year warranty.\"}"
          */
          const data = {
            PreloadedDealID: deal?.preloaded_Deals_ID,
            UserID: parseInt(get(USER_KEY)?.userID),
            CarID: deal?.car_ID,
            DealStatus:
              deal?.deal_Status === DEAL_STATUSES.ACTIVE ? "QuoteApproved" : "QuoteStopped",
            QuoteReusableStartDate: deal?.quote_Reusable_Start_Date,
            QuoteReusableEndDate: deal?.quote_Reusable_End_Date,
            DealName: deal?.deal_Name,
            Notes: deal?.notes,
            SearchBarcode: deal?.search_Barcode,
            DealAssistance: deal?.deal_Assistance,
            Instalment: deal?.instalment,
            RetailIncl: deal?.retail_Incl,
            RateType: deal?.rate_Type,
            RatePercent: deal?.rate_Percent,
            Deposit: deal?.deposit,
            Period: deal?.period,
            BalloonPercent: deal?.balloon_Percent,
            BalloonAmount: deal?.balloon_Amount,
            TotalCostOfCredit: deal?.total_Cost_Of_Credit,
          };
          Object.assign(data, {
            DealJSON: JSON.stringify({
              "dealname-id": data.DealName,
              submitType: "goLive",
              currentDealType: "Live",
              PreloadedDealsID: "", // Will only have if updating deal
              DealStatus: data.DealStatus,
              ToggleStatus: "",
              dealer_comments: data.Notes,
              quoteValidity: "",
              PLDType: "InstalmentPrice",
              "car-section": {
                brand: deal?.brand,
                range: deal?.range,
                model: deal?.model,
                gearshift: deal?.transmission,
                fueltype: deal?.fuel_Type,
                variant: deal?.car_ID,
                dealer_id: "",
                user_id: get(USER_KEY)?.userID,
                car_status: "New",
                mileage: "0",
                vin: JSON.parse(deal?.deal_JSON)?.["car-section"]?.vin,
                color: "Various"
              },
              "options-section": [],
              "additional-fees": [],
              "price-section": {
                standard_price: parseDecimal(calculateVAT(VAT_TYPES.EXCL, data.RetailIncl, vat)),
                discount: 0,
                discount_percent: 0,
                dealer_price: 0,
                total_extras: 0,
                on_road_costs: 0,
                other_costs: 0,
                othercosts_reason: "",
                total_excl: parseDecimal(calculateVAT(VAT_TYPES.EXCL, data.RetailIncl, vat)),
                nonVAT_costs: 0,
                nonVAT: 0,
                vat: 0,
                total_total: parseDecimal(data.RetailIncl),
                "spotter-fee": 0
              },
              "delivery-section": {},
              dealer_attachments: [],
              "validity-section": {
                quoteSentDate: "",
                quoteValidFor: "1",
                quoteToOtherCustomers: "2",
                quoteReusableStartDate: data.QuoteReusableStartDate,
                quoteReusableEndDate: data.QuoteReusableEndDate,
                internalNotes: "Portal_Upload",
                NoStock: "",
                NoStockUntilDate: "",
                NoStockComments: ""
              },
              totals: {
                standard_price: 0,
                discount: 0,
                discount_percent: 0,
                price: 0,
                on_road_costs: 0,
                other_costs: 0,
                extras: 0,
                excl: 0,
                total: 0,
                vat: 0,
                nonVAT: 0,
                incl: 0,
                trade_in_offer: 0,
                trade_in_assist: 0,
                trade_in: 0,
                net: 0
              },
              instalment: {
                Instalment: data.Instalment,
                InstalmentFee: 0,
                Instalment_ExclFee: data.Instalment,
                Instalment_InclFee: data.Instalment,
                Retail_Incl: data.RetailIncl,
                RateType: data.RateType,
                RatePercent: data.RatePercent,
                Deposit: data.Deposit,
                Period: data.Period,
                BalloonPercent: data.BalloonPercent,
                BalloonAmount: data.BalloonAmount,
                TotalCostOfCredit: data.TotalCostOfCredit,
                OEMSubversion: 0,
                DealerSubversion: 0,
                PIC_Code: "",
                ApprovedCAT: "",
                SchemeDealName: data.DealName,
                Comments: data.Notes
              },
              dealer_comments_excerpt: data.Notes
            })
          })
          const resp = await api.updateNewSchemeDeal(data);

          console.log('updateNewSchemeDeal', resp);
          return resp;
        } else if (deal?.plD_Type === DEAL_TYPES.LIST_PRICE) {
          /*
          "preloaded_Deals_ID": 12921,
          "mM_Code": "10323260",
          "brand": "Chery",
          "range": "Tiggo 4 Pro",
          "model": "1.5 Comfort",
          "transaction_Type": "QUOTE",
          "deal_Status": "Active",
          "car_ID": "CherTigg4_1e7",
          "transaction_Datetime": "10/13/2023 15:07:55",
          "deal_Request_Status": "New       ",
          "deal_Request_Amount": 345900.0000,
          "quote_Create_Date": "01/01/1900 00:00:00",
          "quote_Type": "M",
          "quote_Reusable_Start_Date": "10/01/2023 08:54:00",
          "quote_Reusable_End_Date": "12/15/2023 00:00:00",
          "deal_Name": "Total: 345900",
          "plD_Type": "ListPrice",
          "notes": "5 year service plan. 5 year warranty.",
          "search_Barcode": "Chery_Tiggo 4 Pro_1.5 Comfort_345900_10323260_5 year service plan. 5 year warranty.",
          "deal_Assistance": 0.00,
          "transmission": "CVT",
          "fuel_Type": "petrol",
          "deal_JSON": "{\"dealname-id\":\"Total: R 345900\",\"submitType\":\"goLive\",\"currentDealType\":\"Live\",\"PreloadedDealsID\":\"\",\"DealStatus\":\"Active\",\"ToggleStatus\":\"\",\"dealer_comments\":\"5 year service plan. 5 year warranty.\",\"quoteValidity\":\"\",\"PLDType\":\"ListPrice\",\"car-section\":{\"brand\":\"Chery\",\"range\":\"Tiggo 4 Pro\",\"model\":\"1.5 Comfort\",\"gearshift\":\"CVT\",\"fueltype\":\"petrol\",\"variant\":\"CherTigg4_1e7\",\"dealer_id\":\"\",\"user_id\":\"26\",\"car_status\":\"New\",\"mileage\":\"0\",\"vin\":null,\"color\":\"Various\"},\"options-section\":[],\"additional-fees\":[],\"price-section\":{\"standard_price\":300782.61,\"discount\":0,\"discount_percent\":0,\"dealer_price\":0,\"total_extras\":0,\"on_road_costs\":0,\"other_costs\":0,\"othercosts_reason\":\"\",\"total_excl\":300782.61,\"nonVAT_costs\":0,\"nonVAT\":0,\"vat\":0,\"total_total\":350900,\"spotter-fee\":0},\"delivery-section\":{},\"dealer_attachments\":[],\"validity-section\":{\"quoteSentDate\":\"\",\"quoteValidFor\":\"1\",\"quoteToOtherCustomers\":\"2\",\"quoteReusableStartDate\":\"10/01/2023 08:54:00\",\"quoteReusableEndDate\":\"2023-12-15T00:00\",\"internalNotes\":\"Portal_Upload\",\"NoStock\":\"\",\"NoStockUntilDate\":\"\",\"NoStockComments\":\"\"},\"totals\":{\"standard_price\":0,\"discount\":0,\"discount_percent\":0,\"price\":0,\"on_road_costs\":0,\"other_costs\":0,\"extras\":0,\"excl\":0,\"total\":0,\"vat\":0,\"nonVAT\":0,\"incl\":0,\"trade_in_offer\":0,\"trade_in_assist\":0,\"trade_in\":0,\"net\":0},\"instalment\":{\"Instalment\":0,\"InstalmentFee\":0,\"Instalment_ExclFee\":0,\"Instalment_InclFee\":0,\"Retail_Incl\":0,\"RateType\":0,\"RatePercent\":0,\"Deposit\":0,\"Period\":0,\"BalloonPercent\":0,\"BalloonAmount\":0,\"TotalCostOfCredit\":0,\"OEMSubversion\":0,\"DealerSubversion\":0,\"PIC_Code\":\"\",\"ApprovedCAT\":\"\",\"SchemeDealName\":\"Total: R 345900\",\"Comments\":\"5 year service plan. 5 year warranty.\"},\"dealer_comments_excerpt\":\"5 year service plan. 5 year warranty.\"}"
          */
          const data = {
            PreloadedDealID: deal?.preloaded_Deals_ID,
            UserID: parseInt(get(USER_KEY)?.userID),
            CarID: deal?.car_ID,
            DealStatus:
              deal?.deal_Status === DEAL_STATUSES.ACTIVE ? "QuoteApproved" : "QuoteStopped",
            DealRequestAmount: deal?.deal_Request_Amount,
            QuoteReusableStartDate: deal?.quote_Reusable_Start_Date,
            QuoteReusableEndDate: deal?.quote_Reusable_End_Date,
            DealName: deal?.deal_Name,
            Notes: deal?.notes,
            SearchBarcode: deal?.search_Barcode,
            DealAssistance: deal?.deal_Assistance,
          };
          Object.assign(data, {
            DealJSON: JSON.stringify({
              "dealname-id": data.DealName,
              submitType: "goLive",
              currentDealType: "Live",
              PreloadedDealsID: "", // Will only have if updating deal
              DealStatus: data.DealStatus,
              ToggleStatus: "",
              dealer_comments: data.Notes,
              quoteValidity: "",
              PLDType: "ListPrice",
              "car-section": {
                brand: deal?.brand,
                range: deal?.range,
                model: deal?.model,
                gearshift: deal?.transmission,
                fueltype: deal?.fuel_Type,
                variant: data.CarID,
                dealer_id: "",
                user_id: get(USER_KEY)?.userID,
                car_status: "New",
                mileage: "0",
                vin: JSON.parse(deal?.deal_JSON)?.["car-section"]?.vin,
                color: "Various"
              },
              "options-section": [],
              "additional-fees": [],
              "price-section": {
                standard_price: parseDecimal(calculateVAT(VAT_TYPES.EXCL, data.DealRequestAmount, vat)),
                discount: 0,
                discount_percent: 0,
                dealer_price: 0,
                total_extras: 0,
                on_road_costs: 0,
                other_costs: 0,
                othercosts_reason: "",
                total_excl: parseDecimal(calculateVAT(VAT_TYPES.EXCL, data.DealRequestAmount, vat)),
                nonVAT_costs: 0,
                nonVAT: 0,
                vat: 0,
                total_total: parseDecimal(data.DealRequestAmount + deliveryFee?.unit_Price + licenseAndRegFee?.unit_Price),
                "spotter-fee": 0
              },
              "delivery-section": {},
              dealer_attachments: [],
              "validity-section": {
                quoteSentDate: "",
                quoteValidFor: "1",
                quoteToOtherCustomers: "2",
                quoteReusableStartDate: data.QuoteReusableStartDate,
                quoteReusableEndDate: data.QuoteReusableEndDate,
                internalNotes: "Portal_Upload",
                NoStock: "",
                NoStockUntilDate: "",
                NoStockComments: ""
              },
              totals: {
                standard_price: 0,
                discount: 0,
                discount_percent: 0,
                price: 0,
                on_road_costs: 0,
                other_costs: 0,
                extras: 0,
                excl: 0,
                total: 0,
                vat: 0,
                nonVAT: 0,
                incl: 0,
                trade_in_offer: 0,
                trade_in_assist: 0,
                trade_in: 0,
                net: 0
              },
              instalment: {
                Instalment: 0,
                InstalmentFee: 0,
                Instalment_ExclFee: 0,
                Instalment_InclFee: 0,
                Retail_Incl: 0,
                RateType: 0,
                RatePercent: 0,
                Deposit: 0,
                Period: 0,
                BalloonPercent: 0,
                BalloonAmount: 0,
                TotalCostOfCredit: 0,
                OEMSubversion: 0,
                DealerSubversion: 0,
                PIC_Code: "",
                ApprovedCAT: "",
                SchemeDealName: data.DealName,
                Comments: data.Notes
              },
              dealer_comments_excerpt: data.Notes
            })
          })
          const resp = await api.updateNewListPriceDeal(data);
          console.log('updateNewListPriceDeal', resp);
          return resp;
        }
      } else if (scopeID === "used_Car_ID") {
        const carDataPubData = {
          UsedCarID: deal?.used_Car_ID,
          UserID: parseInt(get(USER_KEY)?.userID),

          ReconCost: parseDecimal(deal?.recon_Time),
          ReconTime: parseDecimal(deal?.recon_Time),
          ActiveDeal: deal?.active_Deal === true ? 1 : 0,
          DisplayOnWebsite: deal?.display_On_Website === true ? 1 : 0,
          ActivelyAdvertise: deal?.actively_Advertise === true ? 1 : 0,
          MMCode: deal?.mM_Code,
          VinNumber: deal?.vin_Number,
          Brand: deal?.brand,
          Range: deal?.range,
          Model: deal?.model,
          ModelID: deal?.model_ID,
          SellingPrice: parseDecimal(deal?.selling_Price),
          StandInValue: parseDecimal(deal?.stand_In_Value),
          Mileage: parseDecimal(deal?.mileage),
          Colour: deal?.colour,
          ListDate: deal?.list_Date,
          FirstRegDate: deal?.first_Reg_Date,
          StockLocation: deal?.stock_Location,
          Condition: deal?.condition,
          Transmission: deal?.transmission,
          FuelType: deal?.fuel_Type,
          DealAssistance: parseDecimal(deal?.deal_Assistance),
          Notes: deal?.notes,
          //UploadedPictures: "images",
          SearchBarcode: `${deal?.brand}_${deal?.range}_${deal?.model}_${deal?.selling_Price}_${deal?.mM_Code}_${deal?.notes}`,
        };
        // TODO Check if PLD exists before updating. In SQL, need to make sure PLD fields are coming from PLD and not CDP
        const preloadedDealData = {
          UsedCarID: deal?.used_Car_ID,
          StartDate: deal?.start_Date,
          EndDate: deal?.end_Date,
          AdvertisedPrice: parseDecimal(deal?.advertised_Price),
          RatePercent: parseDecimal(deal?.rate_Percent),
          Deposit: parseDecimal(deal?.deposit),
          Period: parseInt(deal?.period) || 0,
          BalloonPercent: parseDecimal(deal?.balloon_Percent),
          BalloonAmount: parseDecimal(deal?.balloon_Amount),
          TotalCostOfCredit: parseDecimal(deal?.total_Cost_Of_Credit),
        };
        const cdpResp = await api.updateCDPUsedDeal(carDataPubData);
        const pldResp = await api.updatePLDUsedDeal(preloadedDealData);
        console.log('updateCDPUsedDeal', cdpResp);
        console.log('updatePLDUsedDeal', pldResp);
        return { cdpResp, pldResp };
      }
      return deal;
    });
    Promise.all(updatedDeals).then(resps => {
      console.log('resps', resps);
      const successfulResultsCount = resps?.filter(r => r?.success)?.length;
      addToast(TOAST_TYPES.SUCCESS, `${successfulResultsCount}/${resps?.length} successful`, { duration: 1000000 });
      const isError = resps.some(r => !r?.success);
      if (isError) {
        addToast(TOAST_TYPES.ERROR, "Issue updating deal(s).");
      }
      dispatchDeals({
        type: DEAL_ACTIONS.REFETCH_DEALS,
        payload: true,
      });
    });
    //dispatchDeals({ type: DEAL_ACTIONS.SET_DEALS, payload: updatedDeals });
    popEnd();
  };

  const determineInputType = () => {
    switch (fieldToUpdate) {
      case "quote_Reusable_Start_Date":
      case "quote_Reusable_End_Date":
      case "end_Date":
      case "list_Date":
      case "start_Date":
        return "datetime-local";
      case "retail_Incl":
      case "rate_Percent":
      case "period":
      case "instalment":
      case "deposit":
      case "deal_Assistance":
      case "balloon_Percent":
      case "balloon_Amount":
      case "advertised_Price":
      case "mileage":
      case "recon_Cost":
      case "recon_Time":
      case "retail_Price_Excl_VAT":
      case "retail_Price_Incl_VAT":
      case "selling_Price":
      case "stand_In_Value":
        return "number";
      case "deal_Status":
        return "checkbox";
      default:
        break;
    }
  }

  console.log('newValue', newValue);
  console.log('!Boolean(newValue)', !Boolean(newValue));

  return (
    <Modal
      title={`Update deals (${dealsToUpdate?.length})`}
      size={{ width: "60%" }}
      helpMessage={`Updating: ${dealsToUpdate.map((d) => `${d.brand} ${d.range} ${d.model}`).join(", ")}`}
    >
      <StackStyle gap="15px">
        <QueueStyle gap="15px">
          <Select
            options={options}
            value={fieldToUpdate}
            handleChange={(value) => handleOptionChange(value)}
            label="Select field to update"
            prefix={
              <ListChecks size={14} weight="thin" color={colors.secondary} />
            }
            width="100%"
          />
          {determineInputType() === "number" ? (
            <NewValueInput
              type="number"
              value={newValue}
              onChange={(e) => setNewValue(e.target.valueAsNumber)}
              label="New value"
              id="new-value"
              disabled={!fieldToUpdate}
              suffix={
                <span title={`Updating ${fieldToUpdate}`}>
                  <Pencil weight="thin" size={14} />
                </span>
              }
            />
          ) : determineInputType() === "datetime-local" ? (
              <NewValueInput
                type="datetime-local"
                value={newValue}
                onChange={(e) => setNewValue(e.target.value)}
                label={""}
                id="new-value"
                disabled={!fieldToUpdate}
                suffix={
                  <span title={`Updating ${fieldToUpdate}`}>
                    <Pencil weight="thin" size={14} />
                  </span>
                }
              />
            ) : determineInputType() === "checkbox" ? (
              <NewValueInput
                type="checkbox"
                value={newValue}
                checked={newValue === true}
                onChange={(e) => setNewValue(!Boolean(e.target.value))}
                label={""}
                id="new-value"
                disabled={!fieldToUpdate}
                suffix={
                  <span title={`Updating ${fieldToUpdate}`}>
                    <Pencil weight="thin" size={14} />
                  </span>
                }
              />
            ) : (
              <NewValueInput
                type={determineInputType()}
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    label="New value"
                    id="new-value"
                    disabled={!fieldToUpdate}
                    suffix={
                      <span title={`Updating ${fieldToUpdate}`}>
                        <Pencil weight="thin" size={14} />
                      </span>
                    }
                  />
          )}

        </QueueStyle>
        <QueueStyle gap="15px" justifyContent="start">
          <CancelButton onClick={popEnd} />
          <ConfirmButton onClick={handleSubmit} />
        </QueueStyle>
      </StackStyle>
    </Modal>
  );
}

const NewValueInput = inputWithStyle(
  inputWithSuffix(inputWithFloatingLabel(InputBase))
);
